<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <crew-form *ngIf="crew.isLoaded" [freighter]="freighter" [date]="date" [crew]="crew" (back)="onBack()"
             (saved)="onSaved($event)" (statusUpdated)="onStatusUpdated($event)"></crew-form>
</div>
